/**
 * @function idle
 * @description create the idle state for the tarot
 * @param {HTMLElement} element
 * @returns
 */
export default function idle(element) {
    /* adds the idle animation */
    element.classList.add('promote');
    window.setTimeout(function () {
        element.classList.remove('promote');
    }, 250);
    return;
}
